import type {SerializedCompStructure} from '@wix/document-services-types'
import {migrateMegaMenuContainerItemDesign} from './design'
import {migrateMegaMenuContainerItemLayout} from './layout'
import {DROPDOWN_SKIN, megaMenuContainerItemInitialStyleItem} from './constants'
import {isStyleRef} from '../../migratorUtils'

export const migrateMegaMenuContainerItems = (
    megaMenuContainerItems: SerializedCompStructure[],
    menuComponent: SerializedCompStructure
) => {
    const menuProps = menuComponent.props
    const menuStyle = menuComponent.style
    const menuScopedStyles = menuComponent.scopedStyles

    megaMenuContainerItems.forEach(megaMenuContainerItem => {
        if (!isStyleRef(megaMenuContainerItem.style)) {
            throw new Error('MegaMenuContainerItem style is not StyleRef')
        }

        if (!isStyleRef(menuStyle)) {
            throw new Error('Menu root style is not StyleRef')
        }

        if (!menuComponent.referredVariants) {
            throw new Error('Menu component does not have referred variants')
        }

        megaMenuContainerItem.referredVariants = menuComponent.referredVariants
        megaMenuContainerItem.skin = DROPDOWN_SKIN
        megaMenuContainerItem.style.skin = DROPDOWN_SKIN
        migrateMegaMenuContainerItemDesign(menuStyle, megaMenuContainerItem.style)
        migrateMegaMenuContainerItemLayout(menuProps, menuStyle, megaMenuContainerItem.style)

        if (menuScopedStyles) {
            megaMenuContainerItem.scopedStyles = {}

            Object.entries(menuScopedStyles).forEach(([key, styleItem]) => {
                megaMenuContainerItem.scopedStyles![key] = megaMenuContainerItemInitialStyleItem()
                const currentScopedStyle = megaMenuContainerItem.scopedStyles![key]
                migrateMegaMenuContainerItemDesign(styleItem, currentScopedStyle)
                migrateMegaMenuContainerItemLayout(menuProps, styleItem, currentScopedStyle)
            })
        }
    })
}
